<template>
  <div id="config-dialog">
    <el-dialog
      title="流程复制"
      :visible.sync="dialog"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="40%"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="165px"
      >
        <el-form-item label="复制流程名" prop="taskCopyName">
          <el-input v-model="ruleForm.taskCopyName"></el-input>
        </el-form-item>
        <!-- <el-form-item label="插件版本选择" label-width="100px"></el-form-item> -->
        <el-form-item
          v-for="(node, key) in ruleForm.plugins"
          :key="key"
          :label="key"
        >
          <el-select
            style="width: 100%;"
            v-model="ruleForm.plugins[key]"
            placeholder=""
          >
            <el-option
              v-for="item in copyOptions[key]"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="loading" @click="formReset('ruleForm')"
          >取 消</el-button
        >
        <el-button
          :loading="loading"
          type="primary"
          @click="submitForm('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { setTimeout } from "timers";
export default {
  name: "config-dialog",
  props: {
    node: {
      type: Array
    },
    taskId: {
      type: String
    },
    dialog: {
      type: Boolean
    }
  },
  data() {
    const validateName = (rule, value, callback) => {
      let pattern = /[^A-z0-9]/g;
      if (pattern.test(value)) {
        callback(new Error("流程名称仅包含a-z,0-9,A-Z"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        taskCopyName: "",
        plugins: {}
      },
      loading: false,
      rules: {
        taskCopyName: [
          {
            required: true,
            message: "请输入复制的流程名",
            trigger: "blue"
          },
          {
            validator: validateName,
            trigger: "change"
          }
        ]
      },
      copyOptions: {}
    };
  },
  watch: {
    dialog(v) {
      if (v) {
        this.node.forEach(node => {
          this.$set(this.ruleForm.plugins, node.name, node.version);
          this.searchOption(node.name);
        });
      }
    }
  },
  methods: {
    searchOption(key) {
      this.$http
        .get(`/gavial/v1/plugin/view/versions?pkgName=${key}`)
        .then(res => {
          this.$set(this.copyOptions, key, res.data.data);
        });
    },
    formReset(form) {
      this.$refs[form].resetFields();
      this.$emit("update:dialog", false);
    },
    submitForm(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.taskCopy();
        }
      });
    },
    taskCopy() {
      this.loading = true;
      this.ruleForm.taskId = this.taskId;
      this.$http
        .post("/gavial/v1/task/admin/task/copy", this.ruleForm)
        .then(res => {
          this.$emit("addTab", {
            name: res.data.data.name,
            taskId: res.data.data.taskId
          });
          setTimeout(() => {
            this.$notify({
              title: "成功",
              message: `${this.ruleForm.taskCopyName} 复制成功`,
              type: "success",
              duration: 2000
            });
            this.formReset("ruleForm");
            this.$emit("refush");
          }, 500);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
